import { ChangeDetectionStrategy, Component, type OnDestroy } from '@angular/core';
import { v4 as uuid } from 'uuid';
import { DragulaService } from 'ng2-dragula';

@Component({
    selector: 'medsurf-drag-container',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: ``,
    styles: [],
    standalone: false
})
export abstract class DragContainerComponent implements OnDestroy {
  #dragulaUUID: string;
  #dragulaKeys: string[] = [];

  constructor(private dragulaService: DragulaService) {
    this.#dragulaUUID = uuid();
  }

  #createDragulaGroup(key: string) {
    this.dragulaService.createGroup(key, {
      revertOnSpill: true,
      moves: (el: HTMLElement, container: HTMLElement, handle: HTMLElement) => {
        return handle.classList.contains('handle') && handle.closest('.drag-node') === el;
      },
      accepts: (el: HTMLElement, target: HTMLElement, source: HTMLElement) => {
        return target === source;
      },
    });
  }

  getDragulaKey(keyType: string, withUUID = true) {
    const key = withUUID ? this.#dragulaUUID + '-' + keyType : keyType;
    if (this.dragulaService.find(key)) return key;
    this.#createDragulaGroup(key);
    this.#dragulaKeys.push(key);
    return key;
  }

  ngOnDestroy() {
    for (const key of this.#dragulaKeys) {
      this.dragulaService.destroy(key);
    }
    this.#dragulaKeys = [];
  }
}
